module.exports = __webpack_public_path__ + "static/assets/ad93ad726651f5aa12f59233be08e436.png";